import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PalletSuggestionDto } from './pallets-suggestion.dto';

export class SuggestPalletResponseModel extends GlobalResponseObject {
    data?: PalletSuggestionDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: PalletSuggestionDto){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}